import React, { Component } from 'react';
import { Modal, message } from 'antd';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import TableC from '../../../../basicElement/TableC';
import ApproveCancelApply from '../../../../layout/notice/ApproveCancelApply';
import BaBatchTransfer from '../../../../layout/notice/BaBatchTransfer';
import ApproveBaBatchTransfer from '../../../../layout/notice/ApproveBaBatchTransfer';

const Reg = /^([a-zA-Z_]+)_(\d)$/;
const parseQueryConditions = (queryConditions) => {
    const fields = (queryConditions || '').split(',');
    const params = {};
    for (let i = 0, len = fields.length; i < len; i++) {
        const keyValue = fields[i].split('=');
        params[keyValue[0]] = keyValue[1];
    }
    return params;
};
const setSession = (setSession) => {
    if (Object.keys(setSession).length !== 0) {
        for (let [k, v] of Object.entries(setSession)) {
            sessionStorage[k] = v;
        }
    }
}

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
            },
            data: [],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        Fetch.post(API_URL.requestDataAnalysis.queryContractRemittanceNotice, {
            offset: current,
            limit: pageSize,
            ...searchParams,
        }).then(res => {
            const { data, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                pagination,
                loading: false,
                data: data || [],
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    delete = (contractRemittanceDictId, contractRemittanceNoticeDetailId, reload) => {
        Fetch.post(API_URL.requestDataAnalysis.deleteByDetailId, {
            contractRemittanceDictId,
            contractRemittanceNoticeDetailId,
        }).then(() => {
            reload && this.loadData();
        }).catch(error => {
            console.error(error);
        });
    }

    markResolved = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确认标记该类型的消息为已处理？",
            onOk: () => {
                const { contractRemittanceDictId } = record;
                this.setState({ loading: true });
                Fetch.post(API_URL.requestDataAnalysis.markComplete, {
                    contractRemittanceDictId,
                }).then(res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                }).catch(error => {
                    console.error(error);
                    this.setState({ loading: false });
                });
            },
        });
    }

    getColumns = () => {
        const columns = [{
            title: '消息类型',
            dataIndex: 'dictTypeName',
            key: 'dictTypeName',
            width: 200,
        }, {
            title: '消息内容',
            dataIndex: 'content',
            key: 'content',
            width: 800,
            render: (text, record) => {
                const { dictType, dictName, detailList, contractRemittanceDictId } = record;
                const result = [];
                (detailList || []).forEach((item, index, array) => {
                    item.code && result.push(
                        <span key={item.contractRemittanceNoticeDetailId}>
                            【{
                                dictType === 'REMITTANCE_REGISTER_2' ?
                                    <span style={{wordBreak: 'keep-all'}}>{item.code}</span>
                                :
                                    <a style={{wordBreak: 'keep-all'}} onClick={() => this.handleClick(dictType, { ...item, contractRemittanceDictId })}>{item.code}</a>
                            }】
                            {(index < array.length - 1) && '、'}
                        </span>
                    );
                });
                result.unshift(<span key="0">{dictName}{!!result.length ? '：' : '。'}</span>);
                return result;
            }
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 100,
            render: (text, record) => {
                return <a onClick={() => this.markResolved(record)}>标记为已处理</a>;
            }
        }];
        return columns;
    }

    handleClick = (type_key, item) => {
        if (!Reg.test(type_key)) return;
        const type = RegExp.$1;
        const key = +(RegExp.$2 || 0);

        const { roleCode, relatedId, investigationId, queryConditions, contractRemittanceDictId, contractRemittanceNoticeDetailId } = item;
        let path = '';
        let needDelete = false;
        let reload = false;
        let params = parseQueryConditions(queryConditions);
        let session = {
            curRole: roleCode,
            invId: '',
            invName: '',
            investigationSiteCode: '',
            investigationSiteName: '',
            siteId: '',
        };
        switch (type) {
            // 合同请款调整申请通知
            case 'REMITTANCE_ADJUST_APPLY':
            // 客户付款单位调整申请
            case 'REMITTANCE_CUSTOMER_APPLY':
                path = '/#/contractManagement/requestRecord';
                needDelete = key !== 1;
                break;
            // 合同请款通知
            case 'CONTRACT_CASH_REQ':
                path = '/#/contractManagement/requestRecord';
                needDelete = key === 3;
                break;
            // 合同请款记录登记通知
            case 'REMITTANCE_REGISTER':
                if (key === 1) {
                    path = '/#/contractManagement/requestRecord';
                    params.investigationId = investigationId;
                    params.autoAdd = true;
                }
                break;
            // 合同确认请款完成通知
            case 'CONTRACT_COMPLETE_APPLY':
            // 项目确认请款完成通知
            case 'INV_COMPLETE_APPLY':
                path = '/#/contractManagement/contractRecord';
                params.path = '/contractManagement/contractRecord';
                needDelete = key !== 1;
                break;
            // Milestone到达日期通知
            case 'MILESTONE_DATE_REACH_NOTICE':
            // 回款到期提醒
            case 'Refunded_Invoice':
                path = '/#/contractManagement/requestRecord';
                needDelete = true;
                break;
            // 消息通知取消申请
            case 'NOTICE_CANCEL':
                if (key === 1) this.approveCancelApply(relatedId);
                needDelete = key !== 1;
                reload = needDelete;
                break;
            // BA交接通知
            case 'BA_HAND_OVER':
                if (key === 1 || key === 2 || key === 3) {
                    this.baBatchTransfer(key === 1, relatedId);
                } else {
                    this.approveBaBatchTransfer(key === 4, relatedId);
                }
                needDelete = key !== 1 && key !== 4;
                reload = needDelete;
                break;
        }
        
        if (path) {
            this.props.notice.saveParams({...params});
        
            setSession(session);

            location.href = path;
        }

        if (needDelete) this.delete(contractRemittanceDictId, contractRemittanceNoticeDetailId, reload);
    }

    approveCancelApply = (relatedId) => {
        this.approveRef.show(relatedId);
    }

    baBatchTransfer = (approval, relatedId) => {
        this.baTransferRef.show(approval, relatedId);
    }

    approveBaBatchTransfer = (approval, relatedId) => {
        this.approveBaTransferRef.show(approval, relatedId);
    }

    handleChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { height } = this.props;
        const { data, loading, pagination } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    pagination={pagination}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    rowKey="contractRemittanceNoticeId"
                    className="requestMessage"
                />
                <ApproveCancelApply ref={el => this.approveRef = el} loadData={this.loadData} />
                <ApproveBaBatchTransfer ref={el => this.approveBaTransferRef = el} loadData={this.loadData} />
                <BaBatchTransfer ref={el => this.baTransferRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestInfo/RequestMessage/TablePage/List.js